export default [
    {
      path: '/admin/agency/delivery-monitoring',
      name: 'delivery-monitoring',
      meta: { requiresAuth: true },
      component: () => import('@/pages/agency/delivery-monitoring/index.vue')
    }
  ]
